export default{
	phone:{
		chinese:{
			banner:require('@/images/mobile/joinUs/1-1.png'),
			slidingList: ["加入我们", "简单汇生活", "精彩瞬间"],
			//加入我们
			join:{
				title:'加入我们',
				socialRecruitment:'社会招聘',
				bgImage:require('@/images/mobile/joinUs/1-3.png')
			},
			//简单汇生活
			life:{
				title:'简单汇生活',
				lifeOne:{
					lifeTxt:'在简单、温暖的环境中工作',
					contentOne:'汇聚每一份力量：我们给予每一位新人最大的信任与支持，敢于质疑、敢于表达，才能更好地解决问题。我们更希望你有坚持、有担当，积极参与每一次项目讨论、每一次集体活动，凝聚集体的力量，在合作中发现不一样的自己。',
					contentTwo:'成就简单与温暖：我们鼓励每一位员工与主管讨论工作与生活，鼓励简单、有效的沟通。我们也为员工提供丰富的福利政策支持，各种补贴应有尽有，六险一金、年度体检、节日福利及知识管理积分奖励等，让你切身体会简单汇的温暖。',
					contentThree:'链接我和你：简单汇准备了各类团建方式供各部门选择，同时也有大型年度集体活动邀您参与，拉近我们之间的距离。',
				},
				lifeTwo:{
					lifeTxt:'成就更好的我们',
					contentOne:'丰富的学习资源：我们提供丰富的内外部学习资源，为员工提供多维度、全方位的自我提升课程，还有各种名家讲堂、热门课程等学习机会，满足好学的你。',
					contentTwo:'完善的职业发展路径：我们制定了管理、专业双序列晋升通道和完备的人才培养计划，通过专属导师制、轮岗制与“鹰之重生”机制等多项职业发展规划，助你快速熟悉公司工作、找到更好的自己。',
				}
				
			},
			//精彩瞬间
			wonderful:{
				title:'精彩瞬间',
			}
		},
		english:{
			banner:require('@/images/mobile/english/banner_joinus.png'),
			slidingListYW: ["Join us", "Life in JDH", "Wonderful moments"],
			//加入我们
			join:{
				title:'Join us',
				socialRecruitment:'Social recruitment',
				bgImage:require('@/images/mobile/english/joinus_1.png')
			},
			//简单汇生活
			life:{
				title:'Life in JDH',
				lifeOne:{
					lifeTxt:'Working in a simple and warm environment',
					contentOne:'Gather all strength: We give new employees the greatest trust and support. Only when you dare to question and express can we jointly solve problems better. We hope that you can be persistent persons who take responsibility and actively participate in every project discussion and collective activity so that we can gather collective strength and find different selves in cooperation.',
					contentTwo:'Harvest simplicity and warmth: We encourage every employee to discuss work and life with the supervisors, and simple and effective communications are recommended. Besides, we provide employees with abundant welfare policies, including all kinds of subsidies, six social insurance and one housing fund, annual physical examination, holiday benefits and knowledge management bonus points, so that you can experience the warmth in JDH.',
					contentThree:'Link me and you: JDH has prepared various ways of group building for various departments to choose from, and we also invite you to take part in annual large-scale group activities to bring us closer.',
				},
				lifeTwo:{
					lifeTxt:'Growing with JDH',
					contentOne:'Rich learning resources: We provide abundant internal and external learning resources and opportunities for employees, including multi-dimensional and all-round self-improvement courses, various famous lectures and popular courses to satisfy your thirst for learning.',
					contentTwo:'Perfect career development path: We have formulated a double-sequence promotion channel for management and specialty as well as a complete talent training plan. In addition, we can help you quickly get familiar with the work in JDH and improve yourself through many career development plans such as the exclusive tutorial system, the rotation system and the “Eagle Rebirth” mechanism.',
				}
				
			},
			//精彩瞬间
			wonderful:{
				title:'Wonderful moments',
			}
		}
	},
	pc:{
		chinese:{
			banner:require('@/images/joinUs/7-1.png'),
			slidingList: ["加入我们", "简单汇生活", "精彩瞬间"],
			//加入我们
			join:{
				title:'加入我们',
				socialRecruitment:'社会招聘',
				backImg2: {
				  backgroundImage: "url(" + require("@/images/joinUs/7-2.png") + ")",
				  backgroundSize: "cover"
				},
			},
			//简单汇生活
			life:{
				title:'简单汇生活',
				lifeOne:{
					lifeTxt:'在简单、温暖的环境中工作',
					contentOne:'汇聚每一份力量：我们给予每一位新人最大的信任与支持，敢于质疑、敢于表达，才能更好地解决问题。我们更希望你有坚持、有担当，积极参与每一次项目讨论、每一次集体活动，凝聚集体的力量，在合作中发现不一样的自己。',
					contentTwo:'成就简单与温暖：我们鼓励每一位员工与主管讨论工作与生活，鼓励简单、有效的沟通。我们也为员工提供丰富的福利政策支持，各种补贴应有尽有，六险一金、年度体检、节日福利及知识管理积分奖励等，让你切身体会简单汇的温暖。',
					contentThree:'链接我和你：简单汇准备了各类团建方式供各部门选择，同时也有大型年度集体活动邀您参与，拉近我们之间的距离。',
				},
				lifeTwo:{
					lifeTxt:'成就更好的我们',
					contentOne:'丰富的学习资源：我们提供丰富的内外部学习资源，为员工提供多维度、全方位的自我提升课程，还有各种名家讲堂、热门课程等学习机会，满足好学的你。',
					contentTwo:'完善的职业发展路径：我们制定了管理、专业双序列晋升通道和完备的人才培养计划，通过专属导师制、轮岗制与“鹰之重生”机制等多项职业发展规划，助你快速熟悉公司工作、找到更好的自己。',
				}
				
			},
			//精彩瞬间
			wonderful:{
				title:'精彩瞬间',
			}
		},
		english:{
			banner:require('@/images/english/banner_joinus.png'),
			slidingListYW: ["Join us", "Life in JDH", "Wonderful moments"],
			//加入我们
			join:{
				title:'Join us',
				socialRecruitment:'Social recruitment',
				backImg2YW: {
				  backgroundImage:
				    "url(" + require("@/images/english/joinus_1.png") + ")",
				  backgroundSize: "cover"
				},
			},
			//简单汇生活
			life:{
				title:'Life in JDH',
				lifeOne:{
					lifeTxt:'Working in a simple and warm environment',
					contentOne:'Gather all strength: We give new employees the greatest trust and support. Only when you dare to question and express can we jointly solve problems better. We hope that you can be persistent persons who take responsibility and actively participate in every project discussion and collective activity so that we can gather collective strength and find different selves in cooperation.',
					contentTwo:'Harvest simplicity and warmth: We encourage every employee to discuss work and life with the supervisors, and simple and effective communications are recommended. Besides, we provide employees with abundant welfare policies, including all kinds of subsidies, six social insurance and one housing fund, annual physical examination, holiday benefits and knowledge management bonus points, so that you can experience the warmth in JDH.',
					contentThree:'Link me and you: JDH has prepared various ways of group building for various departments to choose from, and we also invite you to take part in annual large-scale group activities to bring us closer.',
				},
				lifeTwo:{
					lifeTxt:'Growing with JDH',
					contentOne:'Rich learning resources: We provide abundant internal and external learning resources and opportunities for employees, including multi-dimensional and all-round self-improvement courses, various famous lectures and popular courses to satisfy your thirst for learning.',
					contentTwo:'Perfect career development path: We have formulated a double-sequence promotion channel for management and specialty as well as a complete talent training plan. In addition, we can help you quickly get familiar with the work in JDH and improve yourself through many career development plans such as the exclusive tutorial system, the rotation system and the “Eagle Rebirth” mechanism.',
				}
				
			},
			//精彩瞬间
			wonderful:{
				title:'Wonderful moments',
			}
		}
	},
}


// WEBPACK FOOTER //
// ./src/utils/lang/joinUs.js